"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _functions = require("../functions.js");

var _condition = require("../events/condition.js");

var _rotationconstraint = require("../rotationconstraint.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/DragRotate
 */


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */

/**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */
var DragRotate =
/** @class */
function (_super) {
  __extends(DragRotate, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DragRotate(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      stopDown: _functions.FALSE
    }) || this;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.altShiftKeysOnly;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.lastAngle_ = undefined;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 250;
    return _this;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  DragRotate.prototype.handleDragEvent = function (mapBrowserEvent) {
    if (!(0, _condition.mouseOnly)(mapBrowserEvent)) {
      return;
    }

    var map = mapBrowserEvent.map;
    var view = map.getView();

    if (view.getConstraints().rotation === _rotationconstraint.disable) {
      return;
    }

    var size = map.getSize();
    var offset = mapBrowserEvent.pixel;
    var theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);

    if (this.lastAngle_ !== undefined) {
      var delta = theta - this.lastAngle_;
      view.adjustRotationInternal(-delta);
    }

    this.lastAngle_ = theta;
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragRotate.prototype.handleUpEvent = function (mapBrowserEvent) {
    if (!(0, _condition.mouseOnly)(mapBrowserEvent)) {
      return true;
    }

    var map = mapBrowserEvent.map;
    var view = map.getView();
    view.endInteraction(this.duration_);
    return false;
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragRotate.prototype.handleDownEvent = function (mapBrowserEvent) {
    if (!(0, _condition.mouseOnly)(mapBrowserEvent)) {
      return false;
    }

    if ((0, _condition.mouseActionButton)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
      var map = mapBrowserEvent.map;
      map.getView().beginInteraction();
      this.lastAngle_ = undefined;
      return true;
    } else {
      return false;
    }
  };

  return DragRotate;
}(_Pointer["default"]);

var _default = DragRotate;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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